import React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from "mobx-react";

@inject("UiStore")
@observer
export class Header extends React.Component {
  render() {
    const explorerUrl = this.props.UiStore.web3Store.explorerUrl || 'https://etherscan.io';
    
    return (
    <header className="header">
        <div className="container">
          <a href="#" className="header-logo"></a>
          <form className="form form_header">
            {/* <Link className="button" to='/retry'>Retry Failed Transaction</Link> */}
            <label htmlFor="network" 
                className="label">视频介绍: <a target="_blank" href='https://coinservice.github.io/coinservice/coinservice.mp4'>
                   点击观看</a>
            </label>
            {/* <select id="network" className="select">
              <option value="">YourTokens</option>
              <option value="">YourTokens 1</option>
              <option value="">YourTokens 2</option>
            </select> */}
          
          </form>
        </div>
    </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Header.js